<template>
  <div>
    <a-button type="primary" @click="showModal">
      BS-OTH-02-001
    </a-button>
    <a-modal v-model="visible" :footer="null">
      <n-card
        style="max-width: 500px;"
        :bordered="false"
        size="huge"
        class="card"
      >
        <div class="title text-center">アカウントを選択</div>
        <div class="description1 w-full text-center">
          ログインするアカウントを選択してください。
        </div>
        <a-button
          size="large"
          text-color="#434547"
          class="choose-btn active-btn"
        >
          <span class="account">
            <i class="icon icon-bor-done"></i>
            株式会社ベネフィットワン
          </span>
        </a-button>
        <a-button
          size="large"
          color="#ffffff"
          text-color="#434547"
          class="choose-btn"
        >
          <span class="account no_active">株式会社パソナ</span>
        </a-button>

        <div class="style-btn">
          <button class="c-btn btn-white left-btn">キャンセル</button>
          <button class="c-btn btn-grey">ログイン</button>
        </div>
      </n-card>
    </a-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
